import React, { FC, useContext } from 'react';

// Components
import { TeamInfo } from './TeamInfo/TeamInfo';

// Utils
import { getLabelValue } from '@sportal365/smp-widget-utils';
import { ConfigContext } from '@velinsi/smp-widgets-ui';

// Types
import { ISubscriberInfo } from '../../../../../../packages/types';
import { INormalizeTeam } from '../../../types';

interface Props {
  teamOne: INormalizeTeam;
  teamTwo: INormalizeTeam;
  showTeamComparison?: boolean;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const TeamComparisonHeader: FC<Props> = ({ teamOne, teamTwo, showTeamComparison, handleClick }) => {
  const { dataLabels } = useContext(ConfigContext);

  if (!showTeamComparison) return null;

  return (
    <div className='team-comparison-container grid grid-cols-[1fr_auto_1fr] gap-4 p-4 items-center'>
      <TeamInfo {...teamOne} withReversedDisplay handleClick={handleClick} />
      <span className='text-6 font-bold text-hiContrast'>{getLabelValue(dataLabels?.VS, 'VS.')}</span>
      <TeamInfo {...teamTwo} handleClick={handleClick} />
    </div>
  );
};
